import React from "react";

export default props => (
<div className="test-page-content-inner test-page-test-finished2">
    <div className="header">
        <i className="far fa-check"></i>
        <h1>Congratulations!</h1>
    </div>
    <p>You have completed the last test and have now completed the assessment. Thank you for your efforts.</p>
    <p>Completing such psychometric assessments requires considerable mental effort and it is normal to feel exhausted afterwards.</p>
    <p>It is also normal to think about the questions after completion and to have some second thoughts about your responses. Remember such tests are designed in a way so that no person can produce a perfect score.</p>
    <p>Please read the leaflet provided by your administrator for more information on psychometric assessments.</p>
    <p>To finish, click on the FINISH button below.</p>
</div>
);
